'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dImport$002dState from "./mealorama.-Import-State.js";
import * as $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417 from "./mealorama.-Import-State$$anon$17.js";
var $p;
function $s_Lmealorama_ImportState$__htmlOnly__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__htmlOnly;
}
export { $s_Lmealorama_ImportState$__htmlOnly__Lmealorama_ImportState as $s_Lmealorama_ImportState$__htmlOnly__Lmealorama_ImportState };
function $s_Lmealorama_ImportState$__urlOnly__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__urlOnly;
}
export { $s_Lmealorama_ImportState$__urlOnly__Lmealorama_ImportState as $s_Lmealorama_ImportState$__urlOnly__Lmealorama_ImportState };
function $s_Lmealorama_ImportState$__title__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__title;
}
export { $s_Lmealorama_ImportState$__title__Lmealorama_ImportState as $s_Lmealorama_ImportState$__title__Lmealorama_ImportState };
function $s_Lmealorama_ImportState$__complete__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__complete;
}
export { $s_Lmealorama_ImportState$__complete__Lmealorama_ImportState as $s_Lmealorama_ImportState$__complete__Lmealorama_ImportState };
function $s_Lmealorama_ImportState$__unparsable__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__unparsable;
}
export { $s_Lmealorama_ImportState$__unparsable__Lmealorama_ImportState as $s_Lmealorama_ImportState$__unparsable__Lmealorama_ImportState };
function $s_Lmealorama_ImportState$__error__Lmealorama_ImportState() {
  $m_Lmealorama_ImportState$();
  return $t_Lmealorama_ImportState$__error;
}
export { $s_Lmealorama_ImportState$__error__Lmealorama_ImportState as $s_Lmealorama_ImportState$__error__Lmealorama_ImportState };
/** @constructor */
function $c_Lmealorama_ImportState$() {
  this.alK = null;
  $n_Lmealorama_ImportState$ = this;
  $t_Lmealorama_ImportState$__htmlOnly = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("htmlOnly", 0);
  $t_Lmealorama_ImportState$__urlOnly = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("urlOnly", 1);
  $t_Lmealorama_ImportState$__title = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("title", 2);
  $t_Lmealorama_ImportState$__complete = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("complete", 3);
  $t_Lmealorama_ImportState$__unparsable = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("unparsable", 4);
  $t_Lmealorama_ImportState$__error = new $j_mealorama$002e$002dImport$002dState$0024$0024anon$002417.$c_Lmealorama_ImportState$$anon$17("error", 5);
  this.alK = new ($j_mealorama$002e$002dImport$002dState.$d_Lmealorama_ImportState.r().C)([$s_Lmealorama_ImportState$__htmlOnly__Lmealorama_ImportState(), $s_Lmealorama_ImportState$__urlOnly__Lmealorama_ImportState(), $s_Lmealorama_ImportState$__title__Lmealorama_ImportState(), $s_Lmealorama_ImportState$__complete__Lmealorama_ImportState(), $s_Lmealorama_ImportState$__unparsable__Lmealorama_ImportState(), $s_Lmealorama_ImportState$__error__Lmealorama_ImportState()]);
}
export { $c_Lmealorama_ImportState$ as $c_Lmealorama_ImportState$ };
$p = $c_Lmealorama_ImportState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ImportState$;
/** @constructor */
function $h_Lmealorama_ImportState$() {
}
export { $h_Lmealorama_ImportState$ as $h_Lmealorama_ImportState$ };
$h_Lmealorama_ImportState$.prototype = $p;
$p.aIb = (function() {
  return this.alK.a6();
});
var $d_Lmealorama_ImportState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ImportState$, "mealorama.ImportState$", ({
  FS: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_ImportState$ as $d_Lmealorama_ImportState$ };
var $n_Lmealorama_ImportState$;
function $m_Lmealorama_ImportState$() {
  if ((!$n_Lmealorama_ImportState$)) {
    $n_Lmealorama_ImportState$ = new $c_Lmealorama_ImportState$();
  }
  return $n_Lmealorama_ImportState$;
}
export { $m_Lmealorama_ImportState$ as $m_Lmealorama_ImportState$ };
var $t_Lmealorama_ImportState$__htmlOnly = null;
function $u_Lmealorama_ImportState$__htmlOnly(x) {
  $t_Lmealorama_ImportState$__htmlOnly = x;
}
export { $t_Lmealorama_ImportState$__htmlOnly as $t_Lmealorama_ImportState$__htmlOnly, $u_Lmealorama_ImportState$__htmlOnly as $u_Lmealorama_ImportState$__htmlOnly };
var $t_Lmealorama_ImportState$__urlOnly = null;
function $u_Lmealorama_ImportState$__urlOnly(x) {
  $t_Lmealorama_ImportState$__urlOnly = x;
}
export { $t_Lmealorama_ImportState$__urlOnly as $t_Lmealorama_ImportState$__urlOnly, $u_Lmealorama_ImportState$__urlOnly as $u_Lmealorama_ImportState$__urlOnly };
var $t_Lmealorama_ImportState$__title = null;
function $u_Lmealorama_ImportState$__title(x) {
  $t_Lmealorama_ImportState$__title = x;
}
export { $t_Lmealorama_ImportState$__title as $t_Lmealorama_ImportState$__title, $u_Lmealorama_ImportState$__title as $u_Lmealorama_ImportState$__title };
var $t_Lmealorama_ImportState$__complete = null;
function $u_Lmealorama_ImportState$__complete(x) {
  $t_Lmealorama_ImportState$__complete = x;
}
export { $t_Lmealorama_ImportState$__complete as $t_Lmealorama_ImportState$__complete, $u_Lmealorama_ImportState$__complete as $u_Lmealorama_ImportState$__complete };
var $t_Lmealorama_ImportState$__unparsable = null;
function $u_Lmealorama_ImportState$__unparsable(x) {
  $t_Lmealorama_ImportState$__unparsable = x;
}
export { $t_Lmealorama_ImportState$__unparsable as $t_Lmealorama_ImportState$__unparsable, $u_Lmealorama_ImportState$__unparsable as $u_Lmealorama_ImportState$__unparsable };
var $t_Lmealorama_ImportState$__error = null;
function $u_Lmealorama_ImportState$__error(x) {
  $t_Lmealorama_ImportState$__error = x;
}
export { $t_Lmealorama_ImportState$__error as $t_Lmealorama_ImportState$__error, $u_Lmealorama_ImportState$__error as $u_Lmealorama_ImportState$__error };
//# sourceMappingURL=mealorama.-Import-State$.js.map
